const en = {
    'user.table.filter_by_email': 'Filter by email',
    'user.table.filter_by_status': 'Filter by status',
    'user.table.filter_by_status_all': 'All',
    'user.table.filter_by_status_enabled': 'Enabled',
    'user.table.filter_by_status_disabled': 'Disabled',
    'user.table.filter_by_deleted': 'Filter by deleted',
    'user.table.filter_by_deleted_all': 'All',
    'user.table.filter_by_deleted_deleted': 'Deleted',
    'user.table.filter_by_deleted_not_deleted': 'Not deleted',
    'user.table.button.create': 'Create user',
    'user.table.title': 'Users',
    'user.table.email': 'Email',
    'user.table.rol': 'Role',
    'user.table.status': 'Status',
    'user.table.actions': 'Actions',
    'user.table.modal.enable.enable': 'Enable',
    'user.table.modal.enable.disable': 'Disable',
    'user.table.modal.enable.done': 'Successfully done',
    'user.table.modal.enable.button.cancel': 'Cancel',
    'user.table.modal.enable.phrase.enable': 'Are you sure you want to enable this user?',
    'user.table.modal.enable.phrase.disable': 'Are you sure you want to disable this user?',
    'user.table.modal.delete.title': 'Delete',
    'user.table.modal.delete.done': 'Successfully done',
    'user.table.modal.delete.phrase': 'Are you sure you want to delete?',
    'user.table.modal.delete.button.cancel': 'Cancel',
    'user.table.modal.delete.button.delete': 'Delete',
    'user.table.button.edit': 'Edit',
    'user.table.modal.restore.title': 'Restore',
    'user.table.modal.restore.done': 'Successfully done',
    'user.table.modal.restore.button.cancel': 'Cancel',
    'user.table.modal.restore.button.restore': 'Restore',
    'user.table.impersonate': 'Log in as',
    'user.table.modal.impersonate.title': 'Log in as user',
    'user.table.modal.impersonate.phrase': 'Are you sure you want to log in as this user?',
    'user.table.modal.impersonate.button.confirm': 'Log in as',
    'user.table.modal.impersonate.button.cancel': 'Cancel',
    'user.impersonate.revert': 'Volver usuario original',
    'user.impersonate.banner_message': 'You are logged in as',

    'user.form.update': 'Update user',
    'user.form.create': 'Create user',
    'user.form.email': 'Email',
    'user.form.password': 'Password',
    'user.form.password_two': 'Repeat password',
    'user.form.role': 'Role',
    'user.form.role_user': 'User',
    'user.form.role_admin': 'Administrator',
    'user.form.permissions': 'Permissions',
    'user.form.permission_groups': 'Groups',
    'user.form.can_access': 'Intranet Access',
    'user.form.enabled': 'Enabled',
    'user.form.cancel': 'Back',
    'user.form.workPhone': 'Work phone',
};

export default en;